import { Location } from 'react-router-dom';

const sanitizeHash = (hash: string) => hash.replace(/^#/, '');

export const addNextUrlParam = (url: string, location: Location) => {
  const next = `${location.pathname}${location.search}${location.hash}`;
  return next === '/' ? url : `${url}#next=${encodeURIComponent(next)}`;
};

export const retainNextUrlParam = (url: string, location: Location) => {
  const next = getNextUrl(location);
  return next === '/' ? url : `${url}#next=${encodeURIComponent(next)}`;
};

export const getNextUrl = (location: Location) => {
  const next = new URLSearchParams(sanitizeHash(location.hash)).get('next');
  return next ?? '/';
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const normalizeUrl = (url: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};

export const getDomain = (url: string) => {
  try {
    const u = new URL(url);
    return u.hostname;
  } catch {
    return null;
  }
};

export const isExternalUrl = (href: string) => {
  try {
    if (href.match(/^https?:\/\//i) || href.startsWith('//')) {
      return true;
    }

    // If it contains a domain (has dots and no leading slash), it's likely external
    if (href.match(/^[^/]*\.[^/]+/) && !href.startsWith('/')) {
      return true;
    }

    // Check if it's a valid URL with a different origin
    const url = new URL(href, window.location.origin);
    return url.origin !== window.location.origin;
  } catch {
    return false;
  }
};
